import  React from 'react';

import { ConfirmationModal } from './confirmation_modal.jsx';

export default class SkipButton extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      menuOpen: false
    }
  }

  toggleOpen(){
    this.setState({
      menuOpen: !this.state.menuOpen
    });
  }

  onConfirm(){
    this.toggleOpen();
    this.props.onConfirm();
  }

  onCancel(){
    this.toggleOpen();
    this.props.onCancel();
  }

  render() {
    return(
      <div className="skip-modal-button">
        <button
          id="skipButton"
          className={"standard-btn " + (this.state.menuOpen ? "menu-open " : "") + (this.props.disabled ? "disabled" : "") }
          onClick={(event) => this.toggleOpen()}
          disabled={this.props.disabled}
        >
        <span> {this.props.buttonText} </span>
        </button>
        <ConfirmationModal
          title={this.props.title}
          confirmText={this.props.confirmText}
          cancelText={this.props.cancelText}
          onClose={() => this.toggleOpen()}
          visible={this.state.menuOpen}
          onConfirm={() => this.onConfirm()}
          onCancel={() => this.onCancel()}
        />
      </div>
    );
  }
}

